import { Form } from '@unform/web';
import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const Container = styled.div`
  width: 100%;
  @media (max-width: ${breakpoints.medium}) {
    padding: 1.6rem 0 3.2rem 0;
    margin: 0 auto;
    width: 90%;
  }
`;

export const BillingMenu = styled.ul`
  display: grid;
  max-width: 136.3rem;
  margin-top: 3rem;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 2rem 2rem;

  @media (max-width: ${breakpoints.medium}) {
    grid-template-columns: 1fr;
    row-gap: 2.4rem;
  }
`;

export const BillingMenuItem = styled.div`
  width: 100%;
`;

export const BillingMenuLink = styled.button`
  display: flex;
  background: none;
  width: 100%;
  padding: 2.4rem 3.2rem;
  justify-content: space-between;
  color: ${({ theme }) => theme.colors.black};
  font-weight: 700;
  font-size: 1.8rem;
  background: #fff;
  box-shadow: 0px 0px 6px #00000021;
  transition: 0.3s;
  border-radius: 4px;

  &:hover {
    background: ${({ theme }) => theme.colors.yellow};
    cursor: pointer;
    transition: 0.3s;
  }
`;

export const BillingOptionMenu = styled(Form)`
  width: 100%;
  display: flex;
  > div {
    width: 260px;
    margin-right: 24px;
  }
`;

export const BillingOption = styled.button<{ selectedOption: boolean }>`
  background: none;

  border-radius: 4px;
  box-shadow: 0px 0px 6px #00000021;
  transition: 0.3s;

  font-weight: 700;
  font-size: 1.6rem;
  color: ${({ theme }) => theme.colors.black};
  background: ${({ theme, selectedOption }) =>
    selectedOption ? theme.colors.yellow : theme.colors.yellow_light};

  width: 18%;
  height: 56px;
  padding: 12px;

  &:hover {
    background: ${({ theme }) => theme.colors.yellow};
    cursor: pointer;
    transition: 0.3s;
  }

  @media (max-width: ${breakpoints.medium}) {
    font-size: 1.3rem;
  }
`;
